






























































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { CompleteCmrRequest, CompleteRequest } from '@/types/request';
import { ModelSelect } from 'vue-search-select';

@Component({
    props: {
        requestId: String,
    },
    mixins: [validationMixin],
    components: {
        ModelSelect,
    },
    data() {
        return {
            ableToReach: false,
            isReviewCompleted: false,
            inCompleteReviewReason: '',
            comments: '',
            isOptOutOfCMR: false,
            options: [
                {
                    value: 'Did not receive phone calls',
                    text: 'Did not receive phone calls',
                },
                {
                    value: 'Did not receive voicemails',
                    text: 'Did not receive voicemails',
                },
                {
                    value: 'Incorrect phone number',
                    text: 'Incorrect phone number',
                },
                {
                    value: 'Thought the calls might be a scam',
                    text: 'Thought the calls might be a scam',
                },
                {
                    value: 'Did not feel well enough to speak to anyone',
                    text: 'Did not feel well enough to speak to anyone',
                },
                {
                    value: 'Language Barrier - Does not speak english',
                    text: 'Language Barrier - Does not speak english',
                },
                {
                    value: 'Other',
                    text: 'Other',
                },
            ],
        };
    },
    validations() {
        const validations = {
            ableToReach : {
                required,
            },
            isReviewCompleted: {
                required,
            },
            inCompleteReviewReason: {
                required,
            },
            isOptOutOfCMR: {
                required,
            },
        };
        if (this.$data.ableToReach === false) {
            delete validations.inCompleteReviewReason;
        }
        return validations;
    },
})
export default class CompleteCmrRequestModal extends Vue {
    private show = true;

    private async completeRequest() {
        const completeCmrRequest: CompleteCmrRequest = {
            ableToReach: this.$data.ableToReach,
            inCompleteReviewReason: this.$data.inCompleteReviewReason,
            isOptOutOfCMR: this.$data.isOptOutOfCMR,
            isReviewCompleted: this.$data.isReviewCompleted,
            comments: this.$data.comments,
        };
        const completeRequest: CompleteRequest = {
            completeCmrRequest,
        };
        const response = await ObjectFactory.getRequestService().completeRequest(this.$props.requestId,
            completeRequest, this.$store.state.serverUrl);
        if (response.success) {
            this.close();
            this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}`,
                query: {requestType: 'cmrRequest'} });
        }
    }

    private close() {
        this.$emit('close');
    }
}
